import React, { Fragment } from "react";
import PropTypes from "kf-proptypes/widgets";
import { t } from "@lingui/macro";

import { SingleLine, SINGLELINE_INPUT_TYPE } from "../index.jsx";
import {
  ICON_SIZE,
  ICON_STROKE,
  KF_ICONS,
  KfIcon
} from "@widgets/common/components/primitives/kf_icon/index.jsx";
import { FieldErrors, FieldLabel } from "@widgets/inputs/index.jsx";

import styles from "./inputpassword.css";

export function PasswordField({
  label,
  id,
  placeholder = t`Password`,
  value,
  errors = [],
  className,
  onBlur,
  onChange,
  onFocus,
  onKeyUp,
  onKeyDown,
  isError,
  readonly,
  readonlyWrap,
  wrapperClassName,
  labelLeftIcon,
  labelRightIcon,
  onEnter
}) {
  return (
    <Fragment>
      {label && (
        <FieldLabel
          label={label}
          leftIcon={labelLeftIcon}
          rightIcon={labelRightIcon}
        />
      )}
      <SingleLine
        id={id}
        placeholder={placeholder}
        value={value}
        className={`base ${className} ${styles.passwordField}`}
        iconRender={(visible) =>
          visible ? (
            <KfIcon
              icon={KF_ICONS.HIDE}
              size={ICON_SIZE.SIZE_16}
              stroke={ICON_STROKE.REGULAR}
            />
          ) : (
            <KfIcon
              icon={KF_ICONS.EYE}
              size={ICON_SIZE.SIZE_16}
              stroke={ICON_STROKE.REGULAR}
            />
          )
        }
        onChange={(value) => {
          onChange && onChange(value);
        }}
        onKeyUp={onKeyUp}
        onKeyDown={onKeyDown}
        onFocus={onFocus}
        onBlur={onBlur}
        type={SINGLELINE_INPUT_TYPE.PASSWORD}
        isError={isError}
        readonly={readonly}
        readonlyWrap={readonlyWrap}
        wrapperClassName={wrapperClassName}
        onPressEnter={onEnter}
      />
      {errors && errors.length > 0 && (
        <FieldErrors errors={errors} targetId={id} />
      )}
    </Fragment>
  );
}

PasswordField.propTypes = {
  label: PropTypes.string,
  id: PropTypes.string,
  placeholder: PropTypes.string,
  visible: PropTypes.bool,
  className: PropTypes.string,
  errors: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func,
  value: PropTypes.string,
  onKeyUp: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onEnter: PropTypes.func,
  /** it will render left icon of label field */
  labelLeftIcon: PropTypes.node,
  /** it will render right icon of label field */
  labelRightIcon: PropTypes.node,
  onKeyDown: PropTypes.func,
  isError: PropTypes.bool,
  readonly: PropTypes.bool,
  readonlyWrap: PropTypes.bool,
  wrapperClassName: PropTypes.string
};
